import FormComponent from "./form-component";
import Input, { FormParams } from "./input";

export default function PasswordInput(params: FormParams) {
  return (
    <FormComponent
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <Input type="password" autoComplete="current-password" {...params} />
    </FormComponent>
  );
}
